<div class="hmhs-dynamic-form mat-typography mat-body mat-app-background">

  <!-- Form Page Heading -->
  @if (formConfig.pages[currentPage]?.showPageHeader) {
    <h1 class="form-heading">
      {{formConfig.pages[currentPage]?.pageHeader}} {{ alreadySubmitted ? 'Archive' : ''}}
    </h1>
  }

  <!-- Form Entries Loop -->
  @if (soaData?.formValue && !invalidSoa) {
    @for (entry of formConfig.pages[currentPage]?.entries; track entry; let i = $index) {
      <div class="form-row"
        [ngClass]="{ 'hide-entry': entry.base?.foreverHidden }">
        <ptl-entry-as-json [entryConfig]="entry" [form]="pageFormGroups" [formConfig]="formConfig">
        </ptl-entry-as-json>
      </div>
    }
    <!-- Form Page Nav BUTTONS -->
    @if (!alreadySubmitted) {
      <div class="form-buttons">
        @if (!isLoading) {
          <button mat-raised-button color="primary" class="submit-button" (click)="submitButton()">
            SUBMIT
          </button>
        }
        @if (isLoading) {
          <mat-spinner [diameter]="25"></mat-spinner>
        }
      </div>
    }
  }

  @if (!soaData?.soaTokenId) {
    <div class="page-error">You must provide an SOA or Referral ID to use this page.</div>
  }

  @if (invalidSoa) {
    <div class="page-error">The ID provided is invalid.</div>
  }
</div>
